import { SiteType } from '@/entities/sites/site-type.enum';
import { SiteStatus } from '@/entities/sites/site-status.enum';
import { IListItem } from '@/entities/list-item.interface';

export interface ISite {
    id: number;
    shortname: string;
    sitename: string;
    abbr: string;
    email: string;
    clickParam: string;
    url: string;
    contactName: string;
    phoneNum: string;
    type: SiteType;
    note: string;
    specialReport: boolean;
    status: SiteStatus;
    avp: boolean;
    useApproveSale: boolean;
}

export function sitesToListItems(sites: ISite[]): IListItem[] {
    return sites.map((x) => {
        return { value: x.id, heading: x.sitename };
    });
}
